import React from "react";
import Finddealer from "../components/Contact/find-dealer"; 
// import Banner from '../comman/Banner/Banner';


const Findadealer = () => {
  return (
    <>
    {/* <Banner 
     index={'contact'}
    /> */}
    <Finddealer/>    
    </>

  )
};

export default Findadealer;